//#region [IMPORT]

import { on, removeListener, sendMessageData } from "api/prokey/prokey.websocket";
import React, { createContext, useEffect, useState } from "react"

//#endregion

const ContextDoctype = createContext()

//-----------------------------------------------------------------
function DoctypeProvider( { children } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ documents, setDocuments ] = useState( { '': [] } );

  const values = {
    documents ,
  };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleDoctypes(data) {
      //-----------------------------------------------------------------
      setDocuments( data?.documents || { '': [] } );
    }

    // Document list is sent when file data is sent
    on( 'FILE_DOCUMENT_LIST', handleDoctypes );

    return () => {
      removeListener( 'FILE_DOCUMENT_LIST' , handleDoctypes );
    };
  }, [] );

  //#endregion

  return (
    <ContextDoctype.Provider value={ values }>
      {children}
    </ContextDoctype.Provider>
  );
};

export { ContextDoctype, DoctypeProvider };